import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import { ensureCurrentUser } from '../../util/data';
import { sendVerificationEmail } from '../../ducks/user.duck';
import { isScrollingDisabled } from '../../ducks/ui.duck';

import { H3, Page, UserNav, LayoutSideNavigation, Icons } from '../../components';

import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';

import css from './TermsOfServicePage.module.css';
import TermsOfServiceContent from './TermsOfServiceContent';

export const TermsOfServicePageComponent = props => {
  const { currentUser, scrollingDisabled, intl } = props;

  const title = `${intl.formatMessage({ id: 'TOS.title' })} | Stay Greedless`;
  const description =
    'Review the Stay Greedless marketplace terms covering accounts, bookings, payments, host responsibilities, and guest responsibilities.';

  return (
    <Page title={title} description={description} scrollingDisabled={scrollingDisabled}>
      <LayoutSideNavigation
        topbar={
          <>
            <TopbarContainer
              currentPage="TOS"
              desktopClassName={css.desktopTopbar}
              mobileClassName={css.mobileTopbar}
              isWhiteBgNav={false}
              isHeaderSticky={true}
            />
            {/* <UserNav currentPage="AboutPage" /> */}
          </>
        }
        hideCssMainClass
        sideNav={null}
        currentPage="TOS"
        footer={<FooterContainer />}
      >
        <TermsOfServiceContent />
      </LayoutSideNavigation>
    </Page>
  );
};

TermsOfServicePageComponent.defaultProps = {};

TermsOfServicePageComponent.propTypes = {
  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  // Topbar needs user info.
  const { currentUser } = state.user;
  return {
    currentUser,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const TermsOfServicePage = compose(
  connect(mapStateToProps, null),
  injectIntl
)(TermsOfServicePageComponent);

export default TermsOfServicePage;
